/** Average all channels into one (point sources are mono; stereo imports are explicitly downmixed). */
export function downmixToMono(channels: Float32Array[]): Float32Array {
  if (channels.length === 0) return new Float32Array(0)
  if (channels.length === 1) return Float32Array.from(channels[0]!)
  const n = channels[0]!.length
  const out = new Float32Array(n)
  for (const ch of channels) for (let i = 0; i < n; i++) out[i]! += ch[i]!
  const k = 1 / channels.length
  for (let i = 0; i < n; i++) out[i]! *= k
  return out
}

/**
 * Build a loop with a smoothed seam: the last `xfade` samples are blended (equal power) into the first
 * `xfade` samples, and the tail is dropped. The result is `xfade` samples shorter than the input and
 * wraps around without a discontinuity.
 */
export function makeSeamlessLoop(data: Float32Array, sampleRate: number, xfadeSeconds = 0.25): Float32Array {
  const n = data.length
  const xfade = Math.min(Math.floor(xfadeSeconds * sampleRate), Math.floor(n / 3))
  if (xfade < 16) return Float32Array.from(data)
  const outLen = n - xfade
  const out = new Float32Array(outLen)
  out.set(data.subarray(0, outLen))
  // out[i] for i < xfade: fade in the head, fade in (from the other side) the tail that would have followed.
  for (let i = 0; i < xfade; i++) {
    const t = (i + 0.5) / xfade
    const head = Math.sin((t * Math.PI) / 2)
    const tail = Math.cos((t * Math.PI) / 2)
    out[i] = data[i]! * head + data[outLen + i]! * tail
  }
  return out
}
